import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorMasterDistrictList = () => {
  const districtList = useCallback((body, callback) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/master-district/list', payload, response => {
      if (response.status_code === 200) {
        const { data } = response
        callback(data)
      }
    })
  }, [])

  return { districtList }
}

export default InteractorMasterDistrictList
